import Communication from '@root/communication';

export default class Customers {
    private static promise: Promise<Response>;
    private static cache: any;

    /*
     * Returns the customer configuration value for the specified key.
     *
     * key: The key of the value stored in config.json.
     */
    static async get(key: string) : Promise<any> {
        await this.all();
        return this.cache[key];
    }

    /*
     * Returns all values in customers.json as a dictionary.
     */
    static async all() : Promise<any> {
        if (!this.promise)
            this.promise = Communication.fetch('customers.json').then(response => response.json());

        const data = await this.promise;
        return this.cache ? this.cache : (this.cache = data);
    }
}